import script from "./UnverifiedAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UnverifiedAccount.vue?vue&type=script&setup=true&lang=js"

import "./UnverifiedAccount.vue?vue&type=style&index=0&id=c18f25f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c18f25f4"]])

export default __exports__